import "../style/form/investigationform.scss";
import { Investigation, Investigationid } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import {
  InvestigationGet,
  presignedurl,
  sidebar_menu,
} from "../../text/apidata";
import axios from "axios";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

let u1 = [];

export default function Admin_access_form(props) {
  const investigationstate = useSelector(
    (state) => state.counter.Investigation
  );
  const investigationid = useSelector((state) => state.counter.Investigationid);
  const [error, seterror] = useState(false);
  const [alert, setalert] = useState(false);
  const [mapurl, setmapurl] = useState([]);
  const [isactive, setisactive] = useState(false);
  console.log(mapurl);

  const [adminaccess, setadminaccess] = useState({
    display_name: "",
    unique_name: "",
    display_order: 0,
  });

  const dispatch = useDispatch();
  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire(
          //   "Deleted!",
          //   "Given Info has been deleted.",
          //   "success"
          // );
          dispatch(Investigation(""));
          setalert(false);
        }
      });
    } else {
      dispatch(Investigation(""));
      setalert(false);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (investigationstate == "Edit") {
      props.loaderchange("true");

      axios({
        method: "get",
        url: sidebar_menu + investigationid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res);
          // setUrl(res.data.data.featured_image);
          // setsubcategoryname(res.data.data.sub_category_name);
          // setisactive(res.data.data.is_active);
          setadminaccess({
            ...adminaccess,
            display_name: res.data.data.display_name,
            unique_name: res.data.data.unique_name,
            display_order: res.data.data.display_order,
          });
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
        });
    }
  }, [investigationid]);

  const validation = (e) => {
    setalert(true);

    console.log(e);
    const { name, value } = e.target;
    setadminaccess({
      ...adminaccess,
      [name]: value,
    });
    if (name == "display_order") {
      if (e.target.value >= 0) {
        setadminaccess({
          ...adminaccess,
          [name]: value,
        });
      } else {
        setadminaccess({
          ...adminaccess,
          [name]: 0,
        });
      }
    }
  };

  const newusercreate = () => {
    // console.log(investigationdata);
    if (
      adminaccess.display_name != "" &&
      adminaccess.unique_name != "" &&
      adminaccess.display_order != 0
    ) {
      if (investigationstate == "Edit") {
        props.loaderchange("true");
        setTimeout(() => {
          axios({
            method: "put",
            url: sidebar_menu + investigationid + "/",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: adminaccess,
          })
            .then((res) => {
              setalert(false);

              console.log(res);
              dispatch(Investigation(""));
              u1 = [];
              // setadminaccess({
              //   ...adminaccess,
              //   investigation_images: [],
              // });
              props.popupalert("true");
              props.popuptext("Investigations updated Successfully");

              setTimeout(() => {
                props.popupalert("false");
              }, 2000);

              props.loaderchange("false");
            })
            .catch((error) => {
              console.log(error, "here");
            });
        }, 500);
      } else {
        axios({
          method: "post",
          url: sidebar_menu,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          data: adminaccess,
        })
          .then((res) => {
            console.log(res);
            u1 = [];
            setalert(false);

            // setinvestigationdata({
            //   ...investigationdata,
            //   investigation_images: [],
            // });

            dispatch(Investigation(""));
            props.popupalert("true");
            props.popuptext("Admin access Created Successfully");

            setTimeout(() => {
              props.popupalert("false");
            }, 2000);

            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      seterror(true);
      // if (
      //   adminaccess.investigation_images == "" ||
      //   adminaccess.featured_image == ""
      // ) {
      //   props.popupalert("true");
      //   props.popuptext("Upload Investigation Images ");

      //   setTimeout(() => {
      //     props.popupalert("false");
      //   }, 2000);
      // }
    }
  };

  return (
    <>
      <div className="maincontainer_productform">
        <div className="parent-productform">
          <div className="create-productform card">
            <div class="modal-header">
              <h5 class="modal-title">
                {investigationstate == "Edit"
                  ? "Admin Access Edit"
                  : "Admin Access Create"}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="modal-body" style={{ padding: "0 !important" }}>
              <form
                style={{ padding: "0 1.5rem 0rem" }}
                className="formspace"
                onSubmit={handleSubmit}
              >
                <div class="form-row">
                  <div class="form-group col-md-6 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Dashboard Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="display_name"
                      autoComplete="off"
                      value={adminaccess.display_name}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && adminaccess.display_name == ""
                        ? "Display Name Required"
                        : ""}{" "}
                    </p>
                  </div>
                  <div class="form-group col-md-6 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Unique Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="unique_name"
                      disabled={investigationstate == "Edit" && true}
                      autoComplete="off"
                      value={adminaccess.unique_name}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && adminaccess.unique_name == ""
                        ? "Unique Name Required"
                        : ""}{" "}
                    </p>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Display order
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="display_order"
                      autoComplete="off"
                      value={adminaccess.display_order}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && adminaccess.display_order == ""
                        ? "Display Order Required"
                        : ""}{" "}
                    </p>
                  </div>
                </div>

                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group col-md-12 pb-3 pt-4 m-0">
                    <button
                      type="submit"
                      class="btn btn-primary  create"
                      onClick={(e) => newusercreate(e)}
                      disabled={
                        investigationstate == "Edit" && !alert ? true : false
                      }
                    >
                      {investigationstate == "Edit"
                        ? "Update Admin Access"
                        : "Create Admin Access"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
